import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    toastContainer: {
        '&.Toastify__toast': {
            borderRadius: theme.spacing(0.25),
            fontSize: theme.typography.h1,
            padding: theme.spacing(3),
            backgroundColor: theme.palette.common.white,
            border: `3px solid #E23645`,
            height: '100px',
            color: 'white',
            '&.Toastify__toast--info': {
                border: `3px solid #63C0DF`,
                background: '#63C0DF',
            },
            '&.Toastify__toast--error': {
                border: `3px solid #E23645`,
                background: '#E23645',
            },
            '&.Toastify__toast--success': {
                background: '#19A34F',
                border: `1px solid #05673F`,
            },
        },
    },
}));
